<template>
  <div class="flex h-80 flex-col items-center justify-center">
    <icon-base height="80" width="80" :icon="IconClipboard" />
    <lf-h3 v-if="noSignedApps" class="mt-4 mb-2">
      No signed applications added yet
    </lf-h3>
    <lf-h3 v-if="noSignedAppsForProductType" class="mt-4 mb-2">
      {{
        $t("DEALS.DOCUMENTS.NO_APPLICATIONS_FOR_PRODUCT_TYPE", {
          productType: getProductType(productType),
        })
      }}
    </lf-h3>
    <p v-if="canEditDealApplicationAndUnderwriting" class="mb-4">
      Please request signed applications or add them manually
    </p>
    <primary-button
      v-if="canEditDealApplicationAndUnderwriting"
      @click.prevent="openModal"
    >
      {{ $t("DEALS.DOCUMENTS.ADD_APPLICATIONS") }}
    </primary-button>
  </div>
</template>
<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";

import { useDeals } from "@/hooks/deals";

import IconClipboard from "@/components/icons/deals/IconClipboard.vue";

import type { FinancialProduct } from "@/models/common";
import type { ProductType } from "@/models/options";
import type { PropType } from "vue";

defineProps({
  openModal: {
    type: Function as PropType<() => void>,
    required: true,
  },
  noSignedApps: {
    type: Boolean as PropType<boolean>,
    required: true,
  },
  noSignedAppsForProductType: {
    type: Boolean as PropType<boolean>,
    required: true,
  },
  productType: {
    type: Number as PropType<ProductType | undefined | null>,
  },
});

const { getters } = useStore();
const { canEditDealApplicationAndUnderwriting } = useDeals();

const productTypes = computed<Record<ProductType, FinancialProduct>>(
  () => getters["options/productTypes"]
);

const getProductType = (productType: ProductType | undefined | null) => {
  if (!productType) {
    return;
  }
  return productTypes.value[productType] ?? "";
};
</script>
